import { useState } from "react";
import {
  Button,
  Container,
  Dropdown, Nav, Navbar
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useLogoutMutation } from "store/services/sso";

// css
import styles from "./Header.module.scss";

// img
import logo from "../../Assets/images/logo.png";
import user from "../../Assets/images/user.png";
import imageLoader from "../../Assets/images/imageLoader.gif";
import ConfirmationPop from "../Modals/ConfirmationPop";
import { userFullName } from "helpers/common";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { NOTIFICATIONS, PROFILE } from "config/paths";
import { useGetProfileQuery } from "store/services/auth";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useGetUnreadNotificationsCountQuery } from "store/services/notifications";

const Header = ({ sidebar, setSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: userInfo, isLoading, isFetching } = useGetProfileQuery();

  const [logout, { isLoading: logoutLoading }] = useLogoutMutation();
  const { data: notificationsCount, isLoading: notificationsCountLoading } = useGetUnreadNotificationsCountQuery(undefined, {
    // The notification socket keeps this cache current after the initial load.
    refetchOnFocus: false,
  });
  const unreadCount = Number(notificationsCount?.count) || 0;
  const unreadCountLabel = unreadCount > 99 ? "99+" : unreadCount;

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const pageName = location.pathname;
  let lastSlashIndex = pageName.lastIndexOf("/");
  let heading;
  if (lastSlashIndex !== -1) {
    const afterLastSlash = pageName.substring(lastSlashIndex + 1);
    heading = afterLastSlash;
  }
  const handleSidebar = () => {
    setSidebar(!sidebar);
  };

  const handleLogout = async () => {
    try {

      setShowLogoutModal(false)
      await logout();
    } catch (err) {
      console.log("Error logging user out", err);
    }
  };

  return (
    <>
      <ConfirmationPop
        confirmation={showLogoutModal}
        setConfirmation={setShowLogoutModal}
        type={"logout"}
        confirmHandler={handleLogout}
      />
      {logoutLoading && <LoadingOverlay />}
      <header
        className={`${styles.siteHeader}  siteHeader bg-white  sticky-top py-1 w-100 border-bottom`}
        style={{ zIndex: 99 }}
      >
        <Container fluid>
          <Navbar expand="lg" className="py-0">
            <Button
              onClick={handleSidebar}
              className="d-lg-none border-0 p-0"
              variant="transparent"
              style={{ width: 30 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M3.75 10.5C3.55109 10.5 3.36032 10.4209 3.21967 10.2803C3.07902 10.1396 3 9.94887 3 9.74996V3.75146C3 3.55255 3.07902 3.36179 3.21967 3.22113C3.36032 3.08048 3.55109 3.00146 3.75 3.00146H9.75C9.94891 3.00146 10.1397 3.08048 10.2803 3.22113C10.421 3.36179 10.5 3.55255 10.5 3.75146V9.74996C10.5 9.94887 10.421 10.1396 10.2803 10.2803C10.1397 10.4209 9.94891 10.5 9.75 10.5H3.75ZM14.25 10.5C14.0511 10.5 13.8603 10.4209 13.7197 10.2803C13.579 10.1396 13.5 9.94887 13.5 9.74996V3.75146C13.5 3.55255 13.579 3.36179 13.7197 3.22113C13.8603 3.08048 14.0511 3.00146 14.25 3.00146H20.2485C20.4474 3.00146 20.6382 3.08048 20.7788 3.22113C20.9195 3.36179 20.9985 3.55255 20.9985 3.75146V9.74996C20.9985 9.94887 20.9195 10.1396 20.7788 10.2803C20.6382 10.4209 20.4474 10.5 20.2485 10.5H14.25ZM3.75 21C3.55109 21 3.36032 20.9209 3.21967 20.7803C3.07902 20.6396 3 20.4489 3 20.25V14.25C3 14.051 3.07902 13.8603 3.21967 13.7196C3.36032 13.579 3.55109 13.5 3.75 13.5H9.75C9.94891 13.5 10.1397 13.579 10.2803 13.7196C10.421 13.8603 10.5 14.051 10.5 14.25V20.25C10.5 20.4489 10.421 20.6396 10.2803 20.7803C10.1397 20.9209 9.94891 21 9.75 21H3.75ZM14.25 21C14.0511 21 13.8603 20.9209 13.7197 20.7803C13.579 20.6396 13.5 20.4489 13.5 20.25V14.25C13.5 14.051 13.579 13.8603 13.7197 13.7196C13.8603 13.579 14.0511 13.5 14.25 13.5H20.2485C20.4474 13.5 20.6382 13.579 20.7788 13.7196C20.9195 13.8603 20.9985 14.051 20.9985 14.25V20.25C20.9985 20.4489 20.9195 20.6396 20.7788 20.7803C20.6382 20.9209 20.4474 21 20.2485 21H14.25Z"
                  fill="#b46c9f"
                />
              </svg>
            </Button>
            <Navbar.Brand className={`${styles.logo} d-lg-none`} href="#">
              <img src={logo} alt="" className={`img-fluid`} />
            </Navbar.Brand>

            <Navbar.Toggle
              className="border-0 p-0"
              aria-controls="navbarScroll"
            />
            <Navbar.Collapse
              className={` justify-content-end w-100`}
              id="navbarScroll"
            >
              <Nav className=" py-2 my-lg-0 align-items-center justify-content-end w-100 gap-10 flex-wrap">
                <div className="right d-flex align-items-center gap-10 flex-wrap">
                  <ul className="list-unstyled ps-0 mb-0 gap-10 d-flex align-items-center justify-content-center">
                    {/* <li className="">
                      <Button
                        className={`${styles.navBtn} text-dark border-0 p-0 position-relative`}
                        variant="transparent"
                      >
                        <span
                          className="count position-absolute p-1 rounded-circle"
                          style={{ background: "#00D957", right: 5, top: 0 }}
                        ></span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="35"
                          height="35"
                          viewBox="0 0 41 41"
                          fill="none"
                        >
                          <circle
                            cx="20.4699"
                            cy="20.8117"
                            r="20.1906"
                            fill="#3DA0AA"
                          />
                          <g clip-path="url(#clip0_1_1061)">
                            <path
                              d="M11.2925 20.2352C11.4031 18.4456 12.035 16.7275 13.1102 15.2927C14.1855 13.8579 15.6572 12.7691 17.3438 12.1605C19.0303 11.552 20.8582 11.4503 22.6018 11.868C24.3455 12.2857 25.9289 13.2045 27.1567 14.5112C28.3845 15.8179 29.203 17.4553 29.5115 19.2216C29.8199 20.9879 29.6047 22.8059 28.8925 24.4513C28.1802 26.0968 27.002 27.4979 25.5031 28.4819C24.0041 29.4658 22.25 29.9896 20.457 29.9887H15.1164C14.1026 29.9877 13.1305 29.5845 12.4136 28.8676C11.6967 28.1506 11.2935 27.1786 11.2925 26.1647V20.2352ZM12.8221 26.1647C12.8221 26.7732 13.0638 27.3568 13.4941 27.7871C13.9244 28.2174 14.5079 28.4591 15.1164 28.4591H20.457C21.5362 28.4586 22.6032 28.2307 23.5883 27.7901C24.5735 27.3496 25.4548 26.7064 26.1746 25.9024C26.898 25.0988 27.4412 24.1498 27.7678 23.1191C28.0944 22.0884 28.1968 20.9998 28.0683 19.9263C27.8653 18.233 27.1045 16.6554 25.9059 15.4422C24.7072 14.229 23.1389 13.4493 21.4482 13.2259C21.1184 13.1846 20.7863 13.1636 20.454 13.1632C18.6716 13.1583 16.9445 13.7811 15.5753 14.9222C14.7757 15.5868 14.1194 16.4068 13.6461 17.3326C13.1728 18.2583 12.8925 19.2706 12.8221 20.3079V26.1647Z"
                              fill="#F2F2F2"
                            />
                            <path
                              d="M23.5291 18.5169H20.47C20.2671 18.5169 20.0726 18.4363 19.9292 18.2929C19.7857 18.1495 19.7052 17.9549 19.7052 17.7521C19.7052 17.5493 19.7857 17.3547 19.9292 17.2113C20.0726 17.0679 20.2671 16.9873 20.47 16.9873H23.5291C23.732 16.9873 23.9265 17.0679 24.0699 17.2113C24.2134 17.3547 24.2939 17.5493 24.2939 17.7521C24.2939 17.9549 24.2134 18.1495 24.0699 18.2929C23.9265 18.4363 23.732 18.5169 23.5291 18.5169Z"
                              fill="#F2F2F2"
                            />
                            <path
                              d="M17.4108 20.0469H23.5291C23.732 20.0469 23.9265 20.1275 24.0699 20.2709C24.2134 20.4143 24.2939 20.6088 24.2939 20.8117C24.2939 21.0145 24.2134 21.209 24.0699 21.3525C23.9265 21.4959 23.732 21.5765 23.5291 21.5765H17.4108C17.2079 21.5765 17.0134 21.4959 16.87 21.3525C16.7266 21.209 16.646 21.0145 16.646 20.8117C16.646 20.6088 16.7266 20.4143 16.87 20.2709C17.0134 20.1275 17.2079 20.0469 17.4108 20.0469Z"
                              fill="#F2F2F2"
                            />
                            <path
                              d="M17.4108 23.1055H23.5291C23.732 23.1055 23.9265 23.186 24.0699 23.3295C24.2134 23.4729 24.2939 23.6674 24.2939 23.8703C24.2939 24.0731 24.2134 24.2676 24.0699 24.4111C23.9265 24.5545 23.732 24.6351 23.5291 24.6351H17.4108C17.2079 24.6351 17.0134 24.5545 16.87 24.4111C16.7266 24.2676 16.646 24.0731 16.646 23.8703C16.646 23.6674 16.7266 23.4729 16.87 23.3295C17.0134 23.186 17.2079 23.1055 17.4108 23.1055Z"
                              fill="#F2F2F2"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1_1061">
                              <rect
                                width="18.3551"
                                height="18.3551"
                                fill="white"
                                transform="matrix(-1 0 0 1 29.6475 11.6338)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </Button>
                    </li> */}
                    <li className="">
                      <Button
                        onClick={() => navigate(NOTIFICATIONS)}
                        className={`${styles.navBtn} ${styles.notificationButton} text-dark border-0 p-0 position-relative`}
                        variant="transparent"
                        aria-label={unreadCount > 0 ? `Notifications, ${unreadCount} unread` : "Notifications"}
                      >
                        {!notificationsCountLoading && unreadCount > 0 && (
                          <span className={styles.notificationCount} aria-hidden="true">
                            {unreadCountLabel}
                          </span>
                        )}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="35"
                          height="35"
                          viewBox="0 0 41 41"
                          fill="none"
                        >
                          <circle
                            cx="20.6613"
                            cy="20.8117"
                            r="20.1906"
                            fill="#B46C9F"
                          />
                          <g clip-path="url(#clip0_1_1057)">
                            <path
                              d="M28.7311 21.6999L27.3912 17.0788C26.9589 15.5898 26.0208 14.2822 24.7257 13.3636C23.4307 12.4451 21.8531 11.9684 20.2435 12.0093C18.6339 12.0501 17.0847 12.6061 15.842 13.589C14.5993 14.5719 13.7344 15.9253 13.3847 17.4342L12.3492 21.9047C12.2126 22.495 12.2158 23.1071 12.3585 23.696C12.5013 24.2849 12.78 24.8355 13.174 25.3071C13.5681 25.7788 14.0674 26.1595 14.6352 26.4211C15.203 26.6827 15.8248 26.8186 16.4546 26.8187H16.7605C17.0039 27.6268 17.5142 28.337 18.2145 28.8424C18.9148 29.3478 19.7672 29.6211 20.6434 29.6211C21.5195 29.6211 22.372 29.3478 23.0723 28.8424C23.7726 28.337 24.2829 27.6268 24.5263 26.8187H24.6739C25.3224 26.8188 25.9621 26.675 26.5431 26.3984C27.1241 26.1218 27.6306 25.72 28.023 25.2244C28.4155 24.7288 28.6832 24.1528 28.8054 23.5414C28.9276 22.93 28.9008 22.2997 28.7273 21.6999H28.7311ZM26.2004 23.8907C26.0229 24.117 25.7928 24.3004 25.5284 24.4264C25.2641 24.5523 24.9728 24.6173 24.6777 24.6161H16.4546C16.1683 24.6161 15.8857 24.5543 15.6277 24.4354C15.3696 24.3165 15.1426 24.1435 14.9635 23.9291C14.7844 23.7147 14.6577 23.4645 14.5928 23.1968C14.5279 22.9292 14.5264 22.651 14.5885 22.3827L15.624 17.904C15.8618 16.8733 16.452 15.9485 17.3005 15.2769C18.149 14.6053 19.2072 14.2255 20.3066 14.198C21.4059 14.1705 22.4833 14.4968 23.3671 15.125C24.251 15.7532 24.8905 16.6472 25.184 17.6647L26.5208 22.2858C26.6015 22.5588 26.6145 22.8461 26.5589 23.1247C26.5032 23.4034 26.3805 23.6657 26.2004 23.8907Z"
                              fill="#F2F2F2"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1_1057">
                              <rect
                                width="18.3551"
                                height="17.6209"
                                fill="white"
                                transform="translate(11.4834 12.001)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </Button>
                    </li>
                    {console.log('userInfo?.therapist_detail?.profile_picture', userInfo?.therapist_detail?.profile_picture === null)}
                    <li className="">
                      <Dropdown>
                        <Dropdown.Toggle
                          className={`${styles.profileLink} ps-3 border-start rounded-0 pe-0 border-0 themeBlue d-flex align-items-center`}
                          variant="transparent"
                          id="dropdown-basic"
                        >
                          {(isLoading || isFetching) ? (
                            <LoadingIndicator size={5} />
                          ) :
                            <>
                              <img
                                src={userInfo?.therapist_detail?.profile_picture || user}
                                style={{ aspectRatio: 1, height: 40, width: 40 }}
                                alt=""
                                className="img-fluid rounded-circle object-fit-cover flex-shrink-0"
                              />
                              <div className="content ps-2">
                                <p className="m-0 fw-bold">{userFullName(userInfo)}</p>
                              </div>
                            </>
                          }
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => navigate(PROFILE)}>Profile</Dropdown.Item>
                          <Dropdown.Item onClick={() => setShowLogoutModal(true)} className="text-danger">
                            Logout
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </ul>
                </div>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      </header>
    </>
  );
};

export default Header;
